import {doGet} from './Base';


const getLinkolnEmails = async (domain) => {
  if (!domain) {
      return [];
  }
  const url = '/linkoln_emails/' + domain;
  return await doGet(url);
};


export {getLinkolnEmails};
export default getLinkolnEmails;
